import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "../context/LanguageContext";

const CATEGORIES_API = "https://erp-elsalab.odoo.com/api/cs/product-categories";

async function fetchCategories(language) {
  const url = `${CATEGORIES_API}?lang=${language}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Failed to fetch categories");
  }
  const payload = await response.json();
  const raw = payload?.data?.[0]?.categories || [];
  return raw.map((c) => ({
    id: c.id,
    name: c.name,
    image: c.image_url,
    link: `/shop-collection-sub?id=${c.id}`,
  }));
}

export function useCategories() {
  const { language } = useLanguage();
  const query = useQuery({
    queryKey: ["product-categories", language],
    queryFn: () => fetchCategories(language),
    staleTime: 5 * 60 * 1000,
  });

  return {
    categories: query.data || [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
}
